export const groupByX = <T>(collection: T[], x = 1) => {

  return collection.reduce((acc, currentObj, idx) => {
    if (idx % x === 0) { acc.push([]); }
    const currentList = acc[acc.length - 1];
    currentList.push(currentObj);
    return acc;
  }, [] as Array<T[]>);

};

export async function getBase64ImageFromUrl(imageUrl: string): Promise<string> {
  const res = await fetch(imageUrl);
  const blob = await res.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener("load", function () {
      resolve(reader.result as string);
    }, false);

    reader.onerror = () => {
      return reject(false);
    };
    reader.readAsDataURL(blob);
  });
}

export async function waitT(t: number = 1000) {
  return new Promise((resolve, _) => {
    // tslint:disable-next-line:no-unused-expression
    setTimeout(() => resolve(t), t);
  });
}

export const euroCurrencyFormat = (price: number | string): string => {
  const priceString = `${price}`;
  if (priceString.length < 4) { return priceString; }
  const L = priceString.length;
  let priceStringResult = '';
  for (let i = 0; i < priceString.length; i += 3) {
    let left = L - i - 3;
    if (left < 0) { left = 0; }
    priceStringResult = `${priceString.substring(left, L - i)} ${priceStringResult}`;
  }
  return priceStringResult.trim();
};
